'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.showFiltersModal = showFiltersModal;
exports.hideFiltersModal = hideFiltersModal;
exports.setSchoolName = setSchoolName;
exports.setIsSearched = setIsSearched;
exports.setStartY = setStartY;
exports.setDoLocation = setDoLocation;
exports.init = init;
exports.loadMoreCUList = loadMoreCUList;
exports.reloadCUList = reloadCUList;
exports.toggleFilter = toggleFilter;
exports.resetFilter = resetFilter;

var _reactRouter = require('react-router');

var t = {
    SET_SCHOOLNAME: '/cu/SET_SCHOOLNAME',
    SET_ISSEARCHED: '/cu/SET_ISSEARCHED',
    SET_STARTY: '/cu/SET_STARTY',
    SET_DO_LOCATION: '/cu/SET_DO_LOCATION',

    CU_LOAD_MORE_CULIST: '/cu/CU_LOAD_MORE_CULIST',
    CU_LOAD_MORE_CULIST_SUCCESS: '/cu/CU_LOAD_MORE_CULIST_SUCCESS',
    CU_LOAD_MORE_CULIST_FAIL: '/cu/CU_LOAD_MORE_CULIST_FAIL',

    CU_RELOAD_CULIST: '/cu/CU_RELOAD_CULIST',
    CU_RELOAD_CULIST_SUCCESS: '/cu/CU_RELOAD_CULIST_SUCCESS',
    CU_RELOAD_CULIST_FAIL: '/cu/CU_RELOAD_CULIST_FAIL',

    CU_GET_FILTERS: '/cu/CU_GET_FILTERS',
    CU_GET_FILTERS_SUCCESS: '/cu/CU_GET_FILTERS_SUCCESS',
    CU_GET_FILTERS_FAIL: '/cu/CU_GET_FILTERS_FAIL',

    CU_TOGGLE_FILTER: '/cu/CU_TOGGLE_FILTER',
    CU_SET_PROVINCE: '/cu/CU_SET_PROVINCE',

    CU_RESET_FILTER: '/cu/CU_RESET_FILTER',
    SHOW_FILTER: '/subject/culist/SHOW_FILTER',
    HIDE_FILTER: '/subject/culist/HIDE_FILTER'
};

var initialState = {
    loading: false,
    schoolName: '',
    filters: [],
    selectedFilters: {},
    pager: {},
    culist: [],
    isSearched: false,
    isFiltered: false,
    hasInited: false,
    doLocation: false,
    startY: 0,
    showFilters: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case t.CU_LOAD_MORE_CULIST_SUCCESS:
            {
                if (!action.result.data.success) {
                    return state;
                }
                var _res = _extends({}, state, {
                    pager: action.result.data.pager
                });
                _res.culist = _res.culist.concat(action.result.data.data);
                return _res;
            }
        case t.CU_RELOAD_CULIST:
            return _extends({}, state, {
                loading: true
            });
        case t.CU_RELOAD_CULIST_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    pager: null,
                    culist: [],
                    isSearched: true,
                    isFiltered: false,
                    hasInited: true,
                    loading: false
                });
            }
            if (action.params.isFiltered) {
                return _extends({}, state, {
                    pager: action.result.data.pager,
                    culist: action.result.data.data,
                    isSearched: true,
                    isFiltered: true,
                    hasInited: true,
                    loading: false
                });
            }
            return _extends({}, state, {
                pager: action.result.data.pager,
                culist: action.result.data.data,
                isSearched: true,
                isFiltered: false,
                hasInited: true,
                loading: false
            });
        case t.CU_RELOAD_CULIST_FAIL:
            return _extends({}, state, {
                loading: false
            });
        case t.CU_GET_FILTERS_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                filters: action.result.data.data
            });
        case t.CU_TOGGLE_FILTER:
            {
                var res = JSON.parse(JSON.stringify(state));
                var selectedFilters = res.selectedFilters[action.filterType];
                selectedFilters = selectedFilters ? selectedFilters : [];
                var i = selectedFilters.map(function (sf) {
                    return sf.id;
                }).indexOf(action.filter.id);
                i > -1 ? selectedFilters.splice(i, 1) : selectedFilters.push(action.filter);
                res.selectedFilters[action.filterType] = selectedFilters;
                return _extends({}, state, {
                    selectedFilters: res.selectedFilters
                });
            }
        case t.CU_RESET_FILTER:
            return _extends({}, state, {
                selectedFilters: {},
                isFiltered: false
            });
        case t.SET_SCHOOLNAME:
            return _extends({}, state, {
                schoolName: action.schoolName
            });
        case t.SET_ISSEARCHED:
            return _extends({}, state, {
                isSearched: action.isSearched
            });
        case t.SET_STARTY:
            return _extends({}, state, {
                startY: action.startY
            });
        case t.SET_DO_LOCATION:
            return _extends({}, state, {
                doLocation: action.doLocation
            });
        case t.SHOW_FILTER:
            return _extends({}, state, {
                showFilters: true
            });
        case t.HIDE_FILTER:
            return _extends({}, state, {
                showFilters: false
            });
        default:
            return state;
    }
}
function showFiltersModal() {
    return {
        type: t.SHOW_FILTER
    };
}

function hideFiltersModal() {
    return {
        type: t.HIDE_FILTER
    };
}
function setSchoolName(schoolName) {
    return {
        type: t.SET_SCHOOLNAME,
        schoolName: schoolName
    };
}

function setIsSearched(value) {
    return {
        type: t.SET_ISSEARCHED,
        isSearched: value
    };
}

function setStartY(y) {
    return {
        type: t.SET_STARTY,
        startY: y
    };
}

function setDoLocation(value) {
    return {
        type: t.SET_DO_LOCATION,
        doLocation: value
    };
}

function init(schoolName) {
    return function (dispatch, getState) {
        dispatch(setSchoolName(schoolName ? schoolName : ''));
        dispatch(_getFilters());
        dispatch(reloadCUList());
    };
}

// export function init(schoolName, mustInit = false) {
//     return (dispatch, getState) => {
//         if (mustInit || !getState().culist.hasInited) {
//             dispatch(setIsSearched(false));
//             dispatch(setSchoolName(schoolName ? schoolName : ''));
//             dispatch(reloadCUList());
//             dispatch(_getFilters());
//             dispatch(setDoLocation(false));
//             dispatch(setStartY(0));
//         } else {//不需要重新加载数据，只需要记录位置
//             dispatch(setDoLocation(true));
//         }
//     }
// }

function _loadMoreCUList(params, callback) {
    return {
        types: [t.CU_LOAD_MORE_CULIST, t.CU_LOAD_MORE_CULIST_SUCCESS, t.CU_LOAD_MORE_CULIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/cu_school/list', params);
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, response) {
                if (callback) {
                    callback();
                }
            }

            return afterSuccess;
        }()
    };
}

function _reloadCUList(params) {
    return {
        types: [t.CU_RELOAD_CULIST, t.CU_RELOAD_CULIST_SUCCESS, t.CU_RELOAD_CULIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/cu_school/list', params);
            }

            return promise;
        }(),
        params: params
    };
}

function _getFilters() {
    return {
        types: [t.CU_GET_FILTERS, t.CU_GET_FILTERS_SUCCESS, t.CU_GET_FILTERS_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/cu_school/filter');
            }

            return promise;
        }()
    };
}

function _createQuery(_ref) {
    var _ref$schoolName = _ref.schoolName,
        schoolName = _ref$schoolName === undefined ? '' : _ref$schoolName,
        pager = _ref.pager,
        selectedFilters = _ref.selectedFilters;

    if (pager && pager.page && pager.page >= pager.totalPages) {
        return;
    }

    var params = {
        schoolName: schoolName,
        page: pager && pager.page ? pager.page + 1 : 1,
        size: pager && pager.size ? pager.size : 20
    };
    params["isFiltered"] = false;
    if (null != params["schoolName"] && "" != params["schoolName"]) {
        params["isFiltered"] = true;
    }
    Object.keys(selectedFilters).map(function (key) {
        var filters = selectedFilters[key];
        if (!filters || filters.length == 0) {
            return;
        } else {
            params["isFiltered"] = true;
        }
        var ids = filters.map(function (filter) {
            return filter.id;
        });
        params[key + 'Ids'] = ids;
    });
    return params;
}

function loadMoreCUList(callback) {
    return function (dispatch, getState) {
        var query = _createQuery(getState().culist);
        if (!!query) {
            dispatch(_loadMoreCUList(query, callback));
        }
    };
}

function reloadCUList() {
    return function (dispatch, getState) {
        var state = getState().culist;
        state.pager = null;
        var query = _createQuery(state);
        dispatch(_reloadCUList(query));
    };
}

function toggleFilter() {
    var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return {
        type: t.CU_TOGGLE_FILTER,
        filterType: filterType,
        filter: filter
    };
}

function resetFilter() {
    return {
        type: t.CU_RESET_FILTER
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/cu/culist.js
// module id = 456
// module chunks = 0